import React from "react";

function Grid({ items, type, teasers, labels, columns, mode, numberItems }) {
  return (
    <div
      data-limit={numberItems}
      className={
        "section v-grid " +
        (numberItems && numberItems <= 4 ? "v-mx-10 " : "v-mx-auto ") +
        (columns == 1
          ? "v-gap-10"
          : type === "portfolio"
            ? "v-gap-10  xl:v-grid-cols-3 lg:v-grid-cols-2"
            : "v-gap-10  md:v-grid-cols-2") +
        " v-grid-cols-1 "
      }
    >
      {items.length > 0 ? (
        items.map((entity, index) => {
          return (
            <div
              className={
                index % 2 && numberItems && numberItems <= 4 ? "md:v-mt-20" : ""
              }
              key={index}
              dangerouslySetInnerHTML={{
                __html: teasers[entity.nid],
              }}
            />
          );
        })
      ) : (
        <div className={"no-results v-p-4 v-transition-none"}>
          {labels["nothing"]}
        </div>
      )}
    </div>
  );
}

export default Grid;
